import React from 'react'
import PageBody from 'Common/Custom/PageBody'
import AddItemBtn from 'Common/Custom/AddItemBtn'
import { HeadingOne } from 'Common/Custom/HeadingOne'

import HallBookingListTable from './Components/HallBookingListTable'

const HallBookingList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Hall Booking List</HeadingOne>
                    <AddItemBtn url="add-hall-booking" title="Create" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <HallBookingListTable />
            </div>
        </PageBody>
    )
}

export default HallBookingList
